import styled from "styled-components";

export const TermsOfServiceContainer = styled.div`
  font-family: serif;
`;
